import * as modalTypes from '../types/Modal';
import { validateSelectedCompany } from './Validators/CompanyValidator'; 
import { validateComplaintType } from './Validators/ComplaintValidator';

import {initDataBySelectedCompany} from './Customer';
import * as modalsTypes from '../const/Modals';
import * as errorActions from './Error';
//Action which allows to hide opened modal


export function hideModal() {
    return {
        type: modalTypes.HIDE_MODAL
    };
}

//Action which allows to open company picker modal
export function openCompanyPickerModal() {
    return {
        type: modalTypes.SHOW_MODAL,
        modalType: modalsTypes.COMPANY_PICKER,
        modalProps: {
            title: "Wybierz firmę",
            footer: "Firmę można wyszukać po NIP, kodzie lub nazwie. NIP należy podać bez myślinków."
        }
    };
}

export function openPurchaseAddressPickerModal() {
    return {
        type: modalTypes.SHOW_MODAL,
        modalType: modalsTypes.PURCHASE_ADDRESS,
        modalProps: {
            title: "Wybierz miejsce zakupu",
            footer: "Firmę można wyszukać po NIP, kodzie lub nazwie. NIP należy podać bez myślinków."
        }
    };
}

export function confirmSelectCompanyModal() {
    return (dispatch, getState) => {
        let selectedCompany = getState().company.selectedRow;
        dispatch(errorActions.clearError());
        try {
            validateSelectedCompany(selectedCompany);
            dispatch(initDataBySelectedCompany(selectedCompany));
            dispatch(hideModal());
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd!",error.message));
        }
    };
}

//Action which allows to open complaint position
export function openComplaintPositionModal(position) {
    return (dispatch, getState) => {
        let complaint = getState().complaint;
        dispatch(errorActions.clearError());
        try {
            validateComplaintType(complaint.complaintType);
            dispatch( {
                type: modalTypes.SHOW_MODAL,
                modalType: modalsTypes.COMPLAINT_POSITION,
                modalProps: {
                    title: "Dodaj pozycję zgłoszenia",
                    complaintPosition: position
                }
            });
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd!",error.message));
        }
    };
   
}

export function openShowRodoClauseModal() {
    return {
        type: modalTypes.SHOW_MODAL,
        modalType: modalsTypes.RODO_CLAUSE,
        modalProps: {
            title: "Klauzula informacyjna RODO",
        }
    };
}

export function openProductPickerModal() {
    return {
        type: modalTypes.SHOW_MODAL,
        modalType: modalsTypes.PRODUCT_PICKER,
        modalProps: {
            title: "Wybierz produkt",
        }
    };
}

export function openUpdateWaybillDataModal(complaintId, waybillNumber, waybillCourier) {
    return {
        type: modalTypes.SHOW_MODAL,
        modalType: modalsTypes.UPDATE_WAYBILL_DATA,
        modalProps: {
            title: "Aktualizacja numeru listu przewozowego",
            complaintId: complaintId,
            waybillNumber: waybillNumber,
            waybillCourier: waybillCourier
        }
    };
}

export function openFilePreviewModal(file) {
    return {
        type: modalTypes.SHOW_MODAL,
        modalType: modalsTypes.FILE_PREVIEW,
        modalProps: {
            title: `Podgląd pliku ${file.name}`,
            file: file
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/Modal.js